import { render, staticRenderFns } from "./customerServices.vue?vue&type=template&id=ff753502&scoped=true"
import script from "./customerServices.vue?vue&type=script&lang=js"
export * from "./customerServices.vue?vue&type=script&lang=js"
import style0 from "./customerServices.vue?vue&type=style&index=0&id=ff753502&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff753502",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff753502')) {
      api.createRecord('ff753502', component.options)
    } else {
      api.reload('ff753502', component.options)
    }
    module.hot.accept("./customerServices.vue?vue&type=template&id=ff753502&scoped=true", function () {
      api.rerender('ff753502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/customerServices.vue"
export default component.exports